import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DynamicFeedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dynamic_feed"}/>
}
